/*@flow*/
import React, { useEffect, useState } from 'react';
import list from 'lib/proforma/templates/List';
import hash from 'lib/hash';
import EventDate from 'comps/Event/Date';
import type { LocalsT } from 'lib/proforma/types';
import toIsoStringWithOffset from 'lib/toIsoStringWithOffset';
import setMinutes from 'date-fns/setMinutes';
import setHours from 'date-fns/setHours';
import setSeconds from 'date-fns/setSeconds';

export default (list.clone({
  AddButton() {
    return null;
  },
  Row({ row }) {
    return <div className="hide">{row.input}</div>;
  },
  Fieldset: ({
    children,
    onChange,
    value,
    namespace,
    hideLabel,
    disabled,
    label,
  }: LocalsT & { hideLabel?: boolean, namespace?: string }) => {
    const props = {
      className: 'fieldset fieldset-depth-2',
      disabled,
    };

    const legend = label && !hideLabel && (
      <label className="col-form-label">{label}</label>
    );

    const mkTimestamp = toIsoStringWithOffset;

    const dateAtHour = (h) => {
      const v = new Date();
      return [[setHours, h], [setMinutes, 0], [setSeconds, 0]].reduce((s, arr) => arr[0](s, arr[1]), v);
    };

    const mkRule = () => {
      const now = new Date();
      return {
        dtstart: mkTimestamp(now),
        dtend: mkTimestamp(now),
        rrule: {
          freq: 'DAILY',
          count: 1,
        },
      };
    };

    const [recurrences, setRecurrences] = useState(value || [mkRule()]);

    useEffect(() => {
      if (value && value.length > 0) {
        setRecurrences(value); // Keep existing value on edit
      } else {
        const newRecurrence = [mkRule()];
        setRecurrences(newRecurrence);
        onChange(newRecurrence); // Ensure value updates for new event
      }
    }, [value, onChange]);

    const handleRecurrenceChange = (newRecurrences) => {
      if (hash(newRecurrences) !== hash(recurrences)) {
        setRecurrences(newRecurrences);
        onChange(newRecurrences);
      }
    };

    return (
      <fieldset {...props}>
        {legend}
        {children}
        <EventDate
          namespace={namespace}
          onChange={handleRecurrenceChange}
          value={recurrences}
        />
      </fieldset>
    );
  },
}): any);